export default {
  welcome: '안녕하세요' , 
  welcome_sir: '님' , 
  totalAssetValue : '총 보유 자산' ,  // Total asset value 
  message: '안녕 i18n !!',
  errorServer: '인터넷 연결이 불안정합니다. 잠시 후 다시 시도해주세요.',
  requiredMessage: '필수 입력 사항입니다.',
  close: '닫기',
  back: '돌아가기',
  cancel: '취소',
  register: '등록',

  login: {
    id: '아이디(이메일)',
    password: '비밀번호',
    autoLogin: '자동 로그인',
    signup: '회원가입',
    forgot: '비밀번호 찾기',
    login: '로그인',
    errors: '아이디(이메일) 혹은 비밀번호를 확인해주세요.',
    requiredMessage: '필수 입력 사항입니다.',
    emailMessage: '유효하지 않은 이메일 주소입니다.'
  },
  signup: {
    id: '아이디(필수)',
    idPlaceholder: '이메일을 입력하세요.',
    password: '비밀번호(필수)',
    passwordPlaceholder: '비밀번호를 입력하세요.',
    confirmPassword: '비밀번호 확인(필수)',
    refferalCode: '추천인 코드 입력',
    refferalCodePlaceholder: '추천인 코드를 입력하세요.',
    back: '돌아가기',
    signup: '회원가입',
    requiredMessage: '필수 입력 사항입니다.',
    emailMessage: '유효하지 않은 이메일 주소입니다.',
    passwordMessage: '비밀번호가 일치하지 않습니다.',
    regexMessage:
      '비밀번호는 영문 대소문자와 숫자, 특수기호 포함 8자 이상이어야 합니다.',
    duplicateMessage: '중복된 이메일입니다.',
    recommendMessage: '잘못된 추천인 코드입니다.',
    withdrawMessage: '탈퇴한 계정은 한달 이후 재가입 가능합니다 .'
  },
  password: {
    title: '비밀번호 찾기',
    email: '이메일',
    emailPlaceholder: '이메일을 입력하세요.',
    request: '비밀번호 찾기',
    invalidMessage: '존재하지 않는 ID입니다.',
    tokenMessage: '잘못된 토큰입니다.',
    desc1: '가입하신 이메일로 인증코드를 전송했습니다.',
    desc2: '5분 안에 이메일로 전송된 인증코드를 입력하세요.',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요.',
    confirmPassword: '비밀번호 확인',
    verificationCode: '인증코드',
    verificationCodePlaceholder: '인증코드를 입력하세요.',
    submit: '비밀번호 변경',
    successMessage: '비밀번호 변경이 완료되었습니다.'
  },
  update: {
    title: '업데이트 예정',
    desc: '기능은 업데이트 예정입니다.'
  },
  home: {
    myWalletAddress: '나의 지갑 주소',
    copyClipboard: '클립보드로 복사',
    copySuccess: '나의 지갑 주소가 클립보드에 복사되었습니다.',
    copyFail: '복사에 실패하였습니다.',
    popup: {
      title: '페이캄 로또 {num}회 선발 결과',
      noPopup: '일주일 간 보지 않기',
      detail: '자세히 보기'
    }
  },
  nft: {
    purchasePrice : '구매가' ,  //  
    quantity : '구매 수량' ,  // 구매 수량  
    qty : '개' ,  // 단위(개) 
    registration : '등록하기' , 
    regConfirm :'등록하시겠습니까?' , 
    regCardMsg :'카드 일련번호를 등록해 주세요.' , // 'Please register your card serial number.'
    serialNumber: '일련번호'  , 


  }, 
  send: {
    smsgPlaceholder:  '메모' , 
    smsgLabel: '메모' , 
    coinLabel: '코인 선택',    
    coinPlaceholder: '송금할 코인을 선택하세요.',
    availableAmount: '송금 가능한 금액',
    pliDesc:
      '이벤트를 통해 지급받은 PLI는 환전신청을 통해 PLP로 전환하셔야 송금이 가능합니다.',
    amountLabel: '보낼 금액',
    amountPlaceholder: '보낼 금액을 입력하세요.',
    addressLabel: '지갑 주소',
    addressPlaceholder: '받는 지갑 주소를 입력하세요.',
    feeLabel: '수수료',
    slow: '느림',
    average: '평균',
    fast: '빠름',
    about: '약',
    feeCaution: '수수료가 너무 낮으면 트랜잭션이 거부될 수 있습니다.',
    expactFee: '예상 수수료',
    send: '송금하기',
    refreshModal: {
      message: '수수료(Gas) 정보 수신에 실패하였습니다.',
      home: '홈으로 이동',
      reload: '수수료 정보 재수신'
    },
    confirmModal: {
      amount: '보낼 금액',
      address: '지갑 주소',
      message: '송금하시겠습니까?',
      cancel: '취소',
      send: '송금하기'
    },
    successModal: {
      title: '송금신청 완료',
      desc: '총 송금액',
      confirm: '송금신청 결과보기'
    },
    authModal:{
      title: '인증코드',
      message: '가입정보로 인증코드가 발송되었습니다.',
      code:  '인증코드(숫자만)',
      checkMsg :'수신한 인증번호를 확인해주세요.',
      cancel: '취소' , 
      confirm: '확인'

    },
    amountRulesRequired: '보낼 금액을 입력하세요.',
    amountRulesConfirmed: '보낼 금액을 확인하세요.',
    smsgLabel :'메모' , 
    smsgPlaceholder:'메모를 입력해주세요.', 
    smsgRules20length :'10글자까지 입력가능합니다.'  , 
    addressRulesRequired: '받는 지갑주소를 입력하세요.',
    addressRulesConfirmed: '유효하지 않은 지갑 주소입니다.',
    coinRulesRequired: '코인을 선택하세요',
    feeMessage: '송금 수수료가 부족합니다.',
    insufficientMessage: '송금 가능한 코인 수량을 확인해주세요.',
    failMessage: '코인 송금에 실패하였습니다.'
  },
  gnb_winResult: '당첨결과',
  gnb_saveNumber: '저장번호',
  gnb_preRound: '지난회차',
  gnb_winCriteria: '당첨기준',
  lotto: {
    imgBanner: 'event-card',
    todayNumber: '오늘의 무료 로또', // Today’s free lotto numbers
    getLottoNumber: '무료로 로또 받기', //Get free lotto ticket
    withPaypal: '현금없이 결제 가능한 페이캄 로또', //Pay with PayPal
    purchase: '결제하기',
    confirmModal: {
      // 로또 신청 팝업
      txt_check: '캄보디아 로또 무료 지급에 동의합니다.',
      imgBanner: 'event-poster',
      amount: '번호 선택하기',
      getFree: '무료로 로또 받기'
    },
    confirmModalResult: {
      // 신청 결과 팝업
      confirm: '확인하기',
      close: '닫기',
      ok1: '무료 캄보디아 로또가 지급되었습니다.',
      ok2: '지급된 로또는 [당첨결과] 페이지에서 확인하세요.',
      err: '오늘은 이미 이벤트에 응모하셨습니다.',
      failMessage: '구매 실패하였습니다. 잠시 후 다시 시도해주십시오.',
      timeoutMessage: '로또 구매가능 시간이 아닙니다.',
      endMessage: '무료 로또는 종료되었습니다.'
    },
    selectNumModal: {
      txt_choseNumber: '{num}개의 번호를 선택하세요.',
      reset: '초기화',
      auto: 'Auto',
      submit: '선택완료',
      modify: '수정완료',
      errorMessage: '더이상 선택할 수 없습니다.',
      countMessage: '번호는 6개를 선택해야합니다.'
    },
    gameNum: '{num}회차',
    congratulation: '축하합니다!',
    prize: '{num}등',
    win: '당첨',
    lose: '낙첨',
    noResult: '미추첨',
    noOrder: '구매 내역이 없습니다.',
    matchBonus: '(보너스 숫자 일치)',
    match: '당첨번호 {num}개 일치',
    prizeUnit: '원',
    prizeNum: '{num}등',
    lottoOrderDesc: '무제한으로 구매 가능한',
    lottoOrderBtn: '로또 구매하러 가기',
    orderModal: {
      message: '로또 1개의 가격은 {price}PLP 또는 {price}PLI 입니다.',
      manual: '수동 선택',
      auto: '자동 선택',
      unlimit: '무제한 구매',
      manualDesc: '로또 번호를 직접 선택하여 구매하실 수 있습니다.',
      autoDesc: '자동으로 선택된 로또 번호를 구매하실 수 있습니다.',
      next: '다음으로'
    },
    attendBtn: '출석체크하기',
    attendMessage1: '출석체크 되었습니다.',
    attendMessage2: `CONFIG/출석체크에서 확인 가능합니다.`
  },
  myNum: {
    //lotto/mynumber
    modify: '수정',
    noMyNum: '저장번호가 없습니다.',
    deleteModal: {
      message: '등록된 번호를 삭제하겠습니까?',
      cancel: '취소',
      submit: '삭제',
      confirmMessage: '번호 삭제가 완료되었습니다.',
      failMessage: '번호 삭제가 실패하였습니다.'
    },
    confirmMessage: '번호 등록이 완료되었습니다.',
    failMessage: '번호 등록이 실패하였습니다.'
  },
  order: {
    //lotto/order
    autoSelection: '자동 선택',
    autoInput1: '자동번호 ',
    autoInput2: ' 장 구매',
    inputPlaceholder: '직접 입력',
    exceedMessage: '* 구매 가능 개수를 초과하였습니다.',
    manualSelection: '수동 선택',
    savedNum: '저장번호',
    purchaseLotto: '로또 구매', // Purchase Lotto
    reset: '초기화',
    submit: '등록',
    modify: '수정',
    purchase: '결제하기',
    modalTitle: '결제수단',
    buyTo: '{name}로 구매하기',
    holding: '보유 ',
    quantity: '구매수량',
    ticket: ' 로또',
    price: '가격',
    fee: '수수료',
    total: '총 결제금액',
    remaining: '예상 잔여금',
    next: '다음으로',
    toBeOpen: '추후 지원될 예정입니다.',
    paypalDesc: '* PayPal 결제 기능은 추후 지원될 예정입니다.',
    feeModal: {
      title: '수수료 안내',
      text1: 'ETH gas station 기준으로 전송속도 ‘Fast’값 적용',
      text2: '낮은 수수료 정책으로 트랜잭션 실패 가능성이 있으며,',
      text3: '이는 PLAPAY 에서 책임지지 않습니다.'
    },
    myNumModal: {
      title: '저장번호',
      message: '저장번호가 없습니다.',
      submit: '선택완료'
    },
    paypalModal: {
      confirm: '로또 구매를 진행하시겠습니까?',
      total: '총 수량',
      cancel: '취소',
      submit: '구매하기'
    },
    chooseMessage: '구매할 번호를 선택해주세요.',
    freeMessage: '무료 로또는 1장만 선택해야합니다.',
    successTitle: '로또 구매 완료',
    successText1: '구매하신 로또 번호는 [당첨결과] 페이지에서',
    successText2: '확인 가능합니다.',
    successBtn: '로또 홈으로'
  },
  pay: {
    //pay
    pay: '결제',    
    updateSoon: '업데이트 예정', // Update Coming Soon
    txt_update: 'pay 기능은 업데이트 예정입니다.' ,  // “Pay” function will be updated.
    scan_do_it : '키오스크에 바코드를 <a href="/#/buy">스캔</a>하세요.', // 'barcode on kiosk scan do it.'
  },
  cards:{
    OwnerInformation: '소유자'  , 
    LastName:'성' ,     
    FirstName : '이름',
    eMail : 'E Mail' , 
    Mobile:'핸드폰' ,
    BirthDay:'생년월일' , 
    Gender :'성별' , 
    NationalityCode:'국가' , 
    IDNumber : '여권번호' , 

    CardInformation: '카드정보' ,
    CardNumber : '카드번호'     ,
    Balance:'잔고', 
    Amount:'금액' , 
    Charged : '충전' , 
    RecommendInformation :'추천 정보' , 
    ReferCode: '추천코드'
  },

  config: {
    TradeHistory:'거래이력' , 
    Notice:'공지사항' , 
    refferalCode: '추천코드', // 'refferal code'
    copyMessage: '추천 가입 URL이 클립보드에 복사되었습니다.',
    shareMessage: '[PLAPAY]지금 회원가입하시면 125PLI 증정!', //이 메세지는 추후 변경 예정
    shareSuccess: '공유가 완료되었습니다.',
    shareFail: '공유하기에 실패하였습니다.',
    lockUp: '락업',
    noLockUp: '락업 중인 코인이 없습니다.',
    swapCoin: '스왑',
    attendanceCheck: '출석체크',
    deposit: '입금',
    withdraw: '출금',
    pliHistory: 'PLI 내역',
    performance: '나의 실적',
    transHistory: '트랜잭션 내역',

    store :'매장' , 
    storeNone : '매장이 없습니다.',

    recommender :'추천인' , 
    recommenderNone : '추천인이 없습니다.',

    ReferralList:'추천인목록' , 
    PaymentHistory:'결제이력' , 
    PaymentHistoryNone:'결제 이력이 없습니다.' , 

    


    logOut: '로그아웃',
    language: '언어',
    submit: '선택완료',
    withdrawMessage1_1: 'PLAPAY을 탈퇴하려면 ',
    here: '여기',
    withdrawMessage1_2: '를 눌러주세요.',
    withdrawMessage2: '탈퇴시 계정 정보와 함께',
    withdrawMessage3: '모든 PLI 포인트는 소멸 됩니다.',
    withdrawMessage4: '탈퇴한 계정은 한달 이후 재가입 가능합니다.',
    withdrawMessage5: '정말 탈퇴하시겠습니까?',
    withdraw: '탈퇴하기',
    logoutMessage: '로그아웃 하시겠습니까?'
  },
  Notice : {
    tiker : '공지' , 
    title : '공지사항' , 
    lists : '목록' ,
    listsNone :'등록된 내용이 없습니다.'  , 
    more : '더보기',
  }, 
  attend: {
    attendanceCheck: '출석체크'
  },
  history: {
    // config/history/eth
    more : '더보기',
    callContract : '컨트랙트 호출',
    noHistory : '트렌잭션 내역이 없습니다.', // There is no history
    detail : '트랜잭션 상세 정보',
    close : '닫기'
  },
  recommend: {
    //config/recommend
    genPromote1: '1대 소개자 목록',
    genPromote2: '2대 소개자 목록',
    paid: '지급',
    join: '가입',
    noReferrals: '가입한 추천인이 없습니다.', // No referrals have been signed up
    myPerformance: '나의 실적',
    people: '명'
  },
  point: {
    //config/point
    join: '회원가입', // Sign up Bonus
    genPromote1: '프로모션 1대추천',
    genPromote2: '프로모션 2대추천',
    attend: '출석 이벤트 지급', // Daily attendance check
    pli_out: 'PLI 환전 신청',
    pli_fee: 'PLI 환전 수수료',
    lottoGive: '로또 당첨금 지급',
    unpaid: '(미지급)',
    paid: '(지급완료)',
    more: '더보기',
    deposit: '입금',
    withdrawal: '출금',
    exchangeApplication: '환전 신청',
    exchangeAmount: '환전 수량',
    amountPlaceholder: '최소 10,000 PLI',
    amountMax: '최대',
    availablePli: '환전 가능 PLI',
    fee: '수수료',
    totalAmount: '총 환전액',
    includeFee: '(수수료포함)',
    close: '닫기',
    successExchange: '환전신청 완료',
    detailResult: '환전신청 결과보기',
    confirmMessage: '환전하시겠습니까?',
    cancel: '취소',
    submitExchange: '환전 신청하기',
    amountError: '10,000 PLI 이상 환전 가능합니다.',
    amountNull: '환전 수량을 입력하세요.',
    insufficientError: '환전 가능 수량을 확인해주세요.',
    xuserError: '환전 신청이 불가능합니다.'
  },
  swap: {
    //config/swap
    selectCoin: '지갑', // Select Coin
    amount: '수량', // Amount to be Swapped
    reset: '초기화',
    requestSwap: '스왑신청',
    errCoin: '스왑하실 지갑을 선택하세요.', // Choose a wallet to swap
    errAmount: '스왑하실 수량을 입력하세요.', // Enter the quantity to be swapped
    messageModal: {
      amountFail: '잔액이 부족합니다.',
      fail: '코인 전송에 실패하였습니다.',
      close: '닫기'
    },
    successModal: {
      title: '스왑신청 완료',
      desc: '스왑신청 수량',
      confirm: '스왑신청 결과보기'
    }
  },
  sms: {
    phone: '휴대전화',
    phonePlaceholder: '전화번호를 입력하세요.',
    codePlaceholder: '인증번호를 입력하세요.',
    codeBtn: '인증번호 받기',
    m01: '유효하지 않은 전화번호입니다.',
    m02: '인증번호를 발송했습니다.',
    m03: '인증번호는 10분간 유효합니다.',
    m04: '문자가 오지 않을 시, 스팸/차단메세지함을 확인해주세요.',
    m05: '유효한 인증코드가 있습니다.',
    m06: '이미 가입된 휴대전화 번호입니다.',
    m07: '당일 인증요청을 초과하였습니다.',
    m08: '익일 인증 가능합니다.',
    m09: '메일정보가 없습니다.',
    m10: '인증번호 전송에 실패하였습니다. 다시 시도해주세요.',
    m11: '인증이 필요합니다.',
    m12: '휴대전화 인증이 확인되었습니다.',
    m13: '일치하는 정보가 없습니다.',
    m14: '인증번호가 일치하지 않습니다.',
    m15: '인증번호를 발송할 수 없습니다.',
    m16: '인증번호를 발송할 수 없습니다.'
  }
}
